import styleInject from '../../node_modules/style-inject/dist/fb3a8d84bb477a96e56a5e12f7d7ac81b9d9799a9277fe852d93ab86a1b81224.cfe-internal.js';

var css_248z = "._UeT_g{display:inline-block;width:36px;transition:width .25s ease-out}._BFhOF{width:100%}._1x3ss>input{padding-right:0!important}._2uo5w>svg{fill:#515559}";
var styles = {"collapsibleSearchInput":"_UeT_g","searchInput":"_BFhOF","searchInputCollapsed":"_1x3ss","iconButton":"_2uo5w"};
var stylesheet="._UeT_g{display:inline-block;width:36px;transition:width .25s ease-out}._BFhOF{width:100%}._1x3ss>input{padding-right:0!important}._2uo5w>svg{fill:#515559}";
styleInject(css_248z);

export { styles as default, stylesheet };
